import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useUI } from '@/context/UIContext';
import { useCart } from '@/hooks/useCart';
import { useSettings } from '@/hooks/queries';
import { retrigger } from '@/lib/retrigger';
import { BagIcon, CloseIcon, LogoMark } from '@/components/ui/Icons';

export function Header() {
  const { openDrawer, focusClose } = useUI();
  const { data: cart } = useCart();
  const { data: settings } = useSettings();
  const count = cart?.count ?? 0;
  const badge = useRef<HTMLSpanElement>(null);
  const prev = useRef(count);

  useEffect(() => {
    if (count > prev.current) retrigger(badge.current, 'pop');
    prev.current = count;
  }, [count]);

  const name = settings?.siteName ?? 'ODRA';

  return (
    <header className="top">
      <div className="left">
        <button className="left" onClick={() => openDrawer('menu')} aria-label="Open menu" aria-haspopup="dialog">
          <span className="burger" aria-hidden="true"><i /><i /><i /></span>
          <span className="t">Menu</span>
        </button>
      </div>
      <Link className="logo" to="/" aria-label={`${name}, home`}>
        <LogoMark />
        {name.toUpperCase()}
      </Link>
      <div className="right">
        <button className="bagbtn" onClick={() => openDrawer('cart')} aria-label={`Open bag, ${count} item${count === 1 ? '' : 's'}`} aria-haspopup="dialog">
          <span className="t">Bag</span>
          <BagIcon />
          <span ref={badge} className={'badge' + (count > 0 ? ' on' : '')} aria-hidden="true">{count}</span>
        </button>
        {focusClose && (
          <button className="closebtn" style={{ display: 'flex' }} onClick={focusClose}>
            Close <CloseIcon />
          </button>
        )}
      </div>
    </header>
  );
}
